<template>
  <div id="container">
    <!-- header -->
    <div id="header">
      <!-- <div id="logo"></div> -->
      <!-- <div id="logo-title">
        JC水电站
        <br />
        <span style="font-size:25px">CHN ENERGY</span>
      </div> -->
      <center>
      <div id="header-title">
        {{$route.params.id==6 ? "临时安全监测系统" : title+'智慧工程管理平台'}}
        <br/>
        <!-- <span style="font-size:15px">Intelligent Information MS</span> -->
      </div>
      </center>
    </div>
    <center>
      <div id="tabs">
        <el-input
          :placeholder="placeholder.username"
          prefix-icon="el-icon-user-solid"
          v-model="login.username"
          style="margin-bottom:15px;"
        ></el-input>
        <el-input
          :placeholder="placeholder.password"
          type="password"
          show-password
          prefix-icon="el-icon-unlock"
          v-model="login.password"
          style="margin-bottom:15px;"
          @keyup.enter.native="doLogin"
        ></el-input>
        <el-button
          :loading="login.loading"
          style="width:100%;background-color:#4ECDC4;border-radius: 50px;"
          @click="doLogin"
          @keyup.enter.native="doLogin"
        >登录</el-button>
        <!-- <el-tabs type="border-card" style="wdith:30%">
        <el-tab-pane>
          <span slot="label">
            <i class="el-icon-edit-outline"></i> 账号登录
          </span>
          <el-input
            :placeholder="placeholder.username"
            prefix-icon="el-icon-user-solid"
            v-model="login.username"
            style="margin-bottom:15px;"
          ></el-input>
          <el-input
            :placeholder="placeholder.password"
            type="password"
            show-password
            prefix-icon="el-icon-unlock"
            v-model="login.password"
            style="margin-bottom:15px;"
            @keyup.enter.native="doLogin"
          ></el-input>
          <el-button
            :loading="login.loading"
            type="primary"
            style="width:100%"
            @click="doLogin"
            @keyup.enter.native="doLogin"
          >登录</el-button>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label">
            <i class="el-icon-camera"></i> 扫码登录
          </span>
          <div id="wx_qrcode"></div>
        </el-tab-pane>
        </el-tabs>-->
      </div>
    </center>
    <!-- footer -->
    <!-- <div id="footer">
      <center>
      <div id="footer-title">版权所有: ***公司<br>通讯地址: 湖北省武汉市 </div>
      </center>
    </div>-->
  </div>
</template>
<script>
import lk from "@/api/lk";
import md5 from "js-md5";
import G from "@/views/common/global";
import {setToken} from '@/utils/auth'
export default {
  data() {
    return {
      placeholder: {
        username: "用户名",
        password: "密码"
      },
      login: {
        username: "",
        password: "",
        loading: false
      },

      title: "",
      project: ""
    };
  },
  mounted() {
    this.getProjectById();
    // var obj = new WxLogin({
    //   self_redirect: true,
    //   id: "wx_qrcode",
    //   appid: "ww8e7eccb8f8344f8e",
    //   scope: "snsapi_login",
    //   redirect_uri:
    //     "http%3a%2f%2fhuaneng.wedam.com.cn%2fwatercontrol%2f%23%2fwxcode"
    //   // state: "",
    //   // style: "",
    //   // href: ""
    // });
  },
  created() {
    console.log('谷歌浏览器登录不上去?')
    console.log('由于谷歌浏览器的SameSite安全机制的问题，浏览器在跨域的时候不允许request请求携带cookie，导致每次sessionId都是新的，这里有个出问题前提：跨域，刚好和调试时的环境情况一致。浏览器版本chrome84.0.4147.135,直接在地址栏里输入chrome://flags/，然后在搜索框里搜索关键字SameSite,找到与之匹配的项SameSite by default cookies，将其设置为Disabled,然后关闭浏览器再打开，请求。如此，同窗口session没超时的情况下，每次请求就不会出现后台sessionId不同的情况。')
  },
  methods: {
    getProjectById() {
      lk.getProjectById({ id: this.$route.params.id }).then(res => {
        this.title = res.data.c_name;
        this.project = res.data;
        localStorage.setItem("project", JSON.stringify(this.project));
        sessionStorage.setItem("project", JSON.stringify(this.project));
      });
    },
    doLogin() {
      if (this.login.username == "" || this.login.password == "") {
        this.$message.error("用户名或密码不能为空");
        return;
      }
      this.login.loading = true;
      lk.login({
        username: this.login.username,
        password: md5(this.login.password),
        projectId: this.$route.params.id
      }).then(res => {
        if (res.code == 200) {
          //add by cyt 2021.4.14 start
          setToken(res.data);
          //add by cyt 2021.4.14 end
          sessionStorage.setItem("username", this.login.username);
          sessionStorage.setItem("token", res.data);
          localStorage.setItem("username", this.login.username);
          localStorage.setItem("token", res.data);
          lk.getMenu({
            username: sessionStorage.getItem("username"),
            projectId: JSON.parse(sessionStorage.getItem("project")).c_id
          }).then(r => {
            if (r.code == 200) {
              let index = false;
              r.data.forEach(element => {
                if (element.c_component && index == false) {
                  this.$router.push(
                    typeof this.$route.query.redirect == "undefined"
                      ? element.c_path
                      : this.$route.query.redirect
                  );
                  index=true;
                }
              });
            } else {
              sessionStorage.removeItem("token");
              this.$message.error("无权限进入系统!");
            }
          });
        } else if (res.code == 201) {
          this.$message.error("用户名或密码错误!");
        } else {
          this.$message.error("系统出现错误,登录失败!");
        }
        this.login.loading = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
#container {
  width: 100%;
  // min-width: 1000px;
  background-image: url("../../assets/金川水电站1.jpg");
  background-attachment: fixed;
  height: 100vh;
  background-repeat: no-repeat;
  // background-position: center;
  // -webkit-background-size: cover; /* 兼容Webkit内核浏览器如Chrome和Safari */
  // -o-background-size: cover; /* 兼容Opera */
  background-size: cover;
}
#header {
  height: 100px;
  // background-color: #0168b7;
  opacity: 0.8;
}
#logo {
  // background-image: url("../../assets/cdlogo.png");
  // background-image: url("../../assets/login_logo.png");
  height: 100px;
  background-repeat: no-repeat;
  margin-left: 50px;
  background-position-y: center;
  display: inline-block;
  width: 300px;
}
#logo-title {
  display: inline-block;
  height: 100px;
  vertical-align: middle;
  margin-left: -210px;
  color: white;
  font-size: 30px;
  font-family: cursive;
  margin-top: -50px;
}
#header-title {
  display: inline-block;
  height: 100px;
  vertical-align: middle;
  // margin-left: 13%;
  color: white;
  font-size: 50px;
  font-family: cursive;
  margin-top: 35px;
}
#footer {
  height: 80px;
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: #9cbbd8;
  opacity: 0.8;
}
#footer-title {
  margin-top: 1%;
}
#tabs {
  // position: absolute;
  // left: 40%;
  // right: 15%;
  width: 400px;
  margin-top: 23%;
}
@media only screen and (max-width: 499px) {
  #tabs {
    width: 300px;
    left: 10%;
    // margin: auto;
    top: 30%;
  }
}
// 415C7F  0089D4
.el-tabs {
  user-select: none;
  border-radius: 10px;
  position: relative;
  background-color: #0089d4;
  border: none;
  opacity: 0.8;
  /deep/ .el-tabs__header {
    border-radius: 10px;
    background-color: #0089d4;
    border: none;
    /deep/ .el-tabs__nav-wrap {
      /deep/ .el-tabs__nav-scroll {
        /deep/ .el-tabs__nav {
          /deep/ .el-tabs__item {
            border: none;
            background-color: none;
            color: antiquewhite;
          }
        }
      }
      border-radius: 10px;
    }
  }
}
/deep/ .el-input__inner {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 50px;
  color: black;
  font-size: 15px;
}
/deep/ .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #0089d4;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue